var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("warehouse-home", {
    attrs: { "config-module": "320004", lob: "SI" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }